import { useCallback, useEffect, useState } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import axios from "axios";
import Lenis from "lenis";
import { Toaster } from "@/components/ui/sonner";
import Header from "@/components/Header";
import Hero from "@/components/Hero";
import SoundFamiliar from "@/components/SoundFamiliar";
import WhyBuilding from "@/components/WhyBuilding";
import Research from "@/components/Research";
import FirstHundred from "@/components/FirstHundred";
import LoadCheck from "@/components/LoadCheck";
import Wall from "@/components/Wall";
import Footer from "@/components/Footer";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const Landing = () => {
  const [stats, setStats] = useState(null);

  const refreshStats = useCallback(() => {
    axios
      .get(`${API}/stats`)
      .then((res) => setStats(res.data))
      .catch(() => {});
  }, []);

  useEffect(() => {
    refreshStats();
    const lenis = new Lenis({ duration: 1.15, smoothWheel: true });
    window.__lenis = lenis;
    let rafId;
    const raf = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(raf);
    };
    rafId = requestAnimationFrame(raf);
    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
      window.__lenis = null;
    };
  }, [refreshStats]);

  return (
    <div className="min-h-screen bg-background text-foreground">
      <Header seats={stats?.seats_claimed ?? null} cap={stats?.seat_cap ?? 100} />
      <main>
        <Hero />
        <SoundFamiliar />
        <WhyBuilding />
        <Research />
        <FirstHundred />
        <LoadCheck onSeatsChanged={refreshStats} />
        <Wall />
      </main>
      <Footer />
    </div>
  );
};

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Landing />} />
        </Routes>
      </BrowserRouter>
      <Toaster theme="dark" position="bottom-center" />
    </div>
  );
}

export default App;
